import { useFileUploader as E, isAcceptTypeValid as y, fileInputAcceptTypes as A } from "@systemeio/file-manager";
import { toast as g } from "@systemeio/ui";
import { useTranslation as F } from "../../../i18n.mjs";
import { ImageNameEnum as S, ImageModeEnum as k } from "../image-enum.mjs";
import { addExistingImageSrc as M, hasUploadedImageSrc as N, addUploadedImageSrc as b } from "./state.mjs";
import { isValidUploadedImage as D, isLocalFileUrl as H, loadImageFromUrl as L, removeUploadingImage as h, isImageNode as x } from "./utils.mjs";
const B = 300, j = (P) => {
  const { t: f } = F(), { createFileUploader: T } = E(), U = async (t, e, s) => {
    try {
      const c = await T().upload({ file: t, source: P });
      if (!c) {
        g.error(f("global.error")), h(s, e);
        return;
      }
      s.state.doc.descendants((d, i) => {
        var r;
        if (x(d) && ((r = d.attrs.uploadingProps) == null ? void 0 : r.id) === e) {
          const a = {
            ...d.attrs,
            src: c.path,
            uploadingProps: null
          };
          return s.dispatch(
            s.state.tr.setNodeMarkup(i, null, a).setMeta("addToHistory", !1)
          ), b(c.path), !1;
        }
        return !0;
      });
    } catch {
      g.error(f("global.error")), h(s, e);
    }
  }, I = async (t, e, s) => {
    if (t.length === 0) return;
    const l = t.map(async (r) => {
      const a = crypto.randomUUID(), n = URL.createObjectURL(r), o = new Image();
      return o.src = n, await new Promise((u) => {
        o.onload = () => u();
      }), { file: r, id: a, src: n, width: o.naturalWidth, height: o.naturalHeight };
    }), c = await Promise.all(l), { schema: d } = e.state;
    let i = e.state.tr, m = 0;
    c.forEach(({ id: r, src: a, width: n, height: o }) => {
      const u = d.nodes[S.Block];
      if (!u) return;
      const p = u.create({
        src: a,
        width: n,
        height: o,
        containerWidth: "auto",
        imageMode: k.BlockCenter,
        uploadingProps: { isUploading: !0, id: r }
      });
      i = i.insert(s + m, p), m += p.nodeSize;
    }), e.dispatch(i), c.forEach(({ file: r, id: a }) => {
      U(r, a, e);
    });
  };
  return { onDrop: (t, e) => {
    if (!e.dataTransfer) return;
    const s = Array.from(e.dataTransfer.files).filter(
      (c) => y(c.type, A.image ?? [])
    );
    if (s.length === 0) return !1;
    e.preventDefault();
    const l = t.posAtCoords({ left: e.clientX, top: e.clientY });
    return I(s, t, (l == null ? void 0 : l.pos) ?? 1), !0;
  }, onPaste: (t, e) => {
    if (!e.clipboardData) return;
    const { clipboardData: s } = e, { selection: l } = t.state, { from: c } = l;
    t.state.doc.descendants((r) => (D(r) && M(r.attrs.src), !0));
    const d = Array.from(s.files).filter(
      (r) => y(r.type, A.image ?? [])
    );
    if (d.length > 0)
      return e.preventDefault(), I(d, t, c), !0;
    const i = s.getData("text/html");
    return i && i.includes("<img") && setTimeout(() => {
      const r = [];
      t.state.doc.descendants((a, n) => {
        if (!D(a)) return !0;
        const o = a.attrs.src;
        if (N(o)) return !0;
        if (H(o)) {
          const p = t.state.tr.delete(n, n + a.nodeSize);
          return t.dispatch(p), !0;
        }
        const u = crypto.randomUUID();
        return r.push({ pos: n, src: o, id: u }), !0;
      }), r.length !== 0 && (r.forEach(({ pos: a, id: n }) => {
        const o = t.state.doc.nodeAt(a);
        if (!o) return;
        const u = {
          ...o.attrs,
          uploadingProps: { isUploading: !0, id: n }
        };
        t.dispatch(
          t.state.tr.setNodeMarkup(a, null, u).setMeta("addToHistory", !1)
        );
      }), r.forEach(async ({ id: a, src: n }) => {
        const o = await L(n);
        if (!o) {
          g.error(f("global.error")), h(t, a);
          return;
        }
        U(o, a, t);
      }));
    }, B), !1;
  } };
};
export {
  j as useImageDropAndUpload
};
